import React from 'react';
import Head from 'next/head';
import { LoginForm } from '~/features/auth';
import Meta from '~/shared/components/meta';
import AuthLayout from '~/widgets/layouts/auth-layout';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const LoginPage = () => {
    // Middleware handles redirects, so we don't need client-side redirect here
    // This prevents redirect loops
    const { t } = useTranslation('common');

    return (
        <AuthLayout>
            <Head>
                <title>{t('auth.login.page_title')}</title>
            </Head>
            <Meta
                title={t('auth.login.meta.title')}
                description={t('auth.login.meta.description')}
            />
            <LoginForm />
        </AuthLayout>
    );
};

export async function getServerSideProps({ locale }: { locale: string }) {
    return {
        props: {
            ...(await serverSideTranslations(locale, ['common'])),
        },
    };
}

export default LoginPage;
